export default __webpack_public_path__ + "static/media/english-to-japanese-screenshot-01.1fd34c4a.png";